if (!customElements.get('infinite-paging')) {
  customElements.define('infinite-paging', class InfinitePaging extends HTMLElement {
    constructor() {
      super();
      this.grid = document.getElementById('product-grid');
      this.currentPage = 1;
      this.pages = parseInt(this.dataset.pages);
      this.target = document.getElementById('product-grid').querySelector('li:nth-last-child(5)');
      if (this.pages > 1) {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          this.currentPage++;
          observer.unobserve(this.target);
          if (this.currentPage > this.pages) return;
          fetch(this.dataset.url + '?page=' + this.currentPage + '&sections=main-collection-grid')
            .then(response => response.json())
            .then(data => {
              const products = new DOMParser()
                .parseFromString(data['main-collection-grid'], 'text/html')
                .querySelectorAll('li');
              this.grid.append(...products);
              this.grid.querySelectorAll('img')
                .forEach(img => {
                  const srcset = img.getAttribute('srcset');
                  img.setAttribute('srcset', '');
                  img.setAttribute('srcset', srcset);
                });
              this.target = document.getElementById('product-grid').querySelector('li:nth-last-child(5)');
              observer.observe(this.target);
            })
            .catch(e => {
              console.error(e);
            });
        }
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 0px 0px'}).observe(this.target);
      }
    }
  });
}